var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLineDownRight = function SvgIconArrowLineDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zM6.793 7.543a1 1 0 0 1 1.414 0L17 16.336V9.375a1 1 0 1 1 2 0v9.378c0 .272-.11.518-.286.698l-.013.013a1 1 0 0 1-.698.286H8.625a1 1 0 1 1 0-2h6.96L6.794 8.957a1 1 0 0 1 0-1.414"
  }))));
};
export default SvgIconArrowLineDownRight;